import { useState, useEffect } from 'react';

function Realtime() {

  const webcamUrl = "https://soho.nascom.nasa.gov/data/realtime/hmi_igr/1024/latest.jpg";

  const [imageUrl, setImageUrl] = useState(webcamUrl);
  
    useEffect(() => {
      const intervalId = setInterval(() => {
        // Forzar una nueva carga de la imagen añadiendo un timestamp como parámetro
        const timestamp = new Date().getTime();
        setImageUrl(`${webcamUrl}?t=${timestamp}`);
      }, 5 * 60 * 1000); // 5 minutos en milisegundos
  
      // Limpiar el intervalo cuando el componente se desmonte
      return () => clearInterval(intervalId);
    }, [webcamUrl]); // Dependencia en webcamUrl para que se reinicie si la URL cambia


  return (
    <div className='mt-3'>

      <div className='row mb-5'>
        <div className='col-md-4'>
            <iframe width="100%" height="300px" src="https://embed.windy.com/embed.html?type=map&location=coordinates&metricRain=default&metricTemp=default&metricWind=default&zoom=6&overlay=satellite&product=satellite&level=surface&lat=27.897&lon=-16.106&detailLat=28.30256701471853&detailLon=-16.506958007812504" frameborder="0"></iframe>
            <div className='fs-6 text-secondary'>{"Meteosat Blue"}</div>
        </div>
        <div className='col-md-4'>
          <div
              style={{
                backgroundImage: "url('https://eumetview.eumetsat.int/static-images/latestImages/EUMETSAT_MSG_IR039Color_WesternAfrica.jpg')",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "-220px -140px",
                width: "100%",
                height: "80%",
              }}
              className='border border-1 border-secondary'
            >
            </div>
            <div className='fs-6 text-secondary'
                style={{
                  backgroundImage: "url('https://eumetview.eumetsat.int/static-images/latestImages/EUMETSAT_MSG_IR039Color_WesternAfrica.jpg')",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "bottom right",
                  width: "100%",
                  height: "40px",
                }}
              >
            </div>
              <div className='fs-6 text-secondary'>Meteosat IR 3.9&mu;m</div>
          </div>

          <div className='col-md-4'>
              <iframe width="100%" height="300px" src="https://embed.windy.com/embed.html?type=map&location=coordinates&metricRain=default&metricTemp=default&metricWind=default&zoom=6&overlay=radar&product=radar&level=surface&lat=27.897&lon=-16.106&detailLat=28.30256701471853&detailLon=-16.506958007812504" frameborder="0"></iframe>
            <div className='fs-6 text-secondary'>{"Radar"}</div>

          </div>
      </div>

      <div className='row my-3'>

        <div className='col-md-6'>
          <img
            src= {imageUrl}
            id="sdo-image"
            alt={"SDO/HMI Continuum"}
            title="SDO/HMI Continuum"
            style={{ maxWidth: '100%', height: 'auto' }}
            className='border border-1 border-secondary'
          />
          <div className='fs-6 text-secondary d-flex justify-content-between'>
            {"SDO/HMI Continuum"}  <a className='float-right' target='_blank' title='SDO/HMI Continuum Image' href='https://soho.nascom.nasa.gov/data/realtime/hmi_igr/512/'>SDO/HMI</a>
          </div>
        </div>
        <div className='col-md-6'>
          <img
            src="https://ocan.iac.es/gong-ot-halpha/index.php" 
            alt={"GONG-OT H alpha"}
            title="GONG H alpha"
            style={{ maxWidth: '100%', height: 'auto' }}
            className='border border-1 border-secondary'
          />
          <div className='fs-6 text-secondary d-flex justify-content-between'>
            {"GONG-OT H alpha"}
            <a className='float-right' target='_blank' title='NSO/GONG H-Alpha site images' href='https://gong2.nso.edu/products/scaleView/view.php?configFile=configs/hAlpha.cfg&productIndex=2'>NSO/GONG</a>
            </div>
        </div>
    
      </div>

    </div>

  );


/* 

const [imageUrl, setImageUrl] = useState(webcamUrl);

useEffect(() => {
  const intervalId = setInterval(() => {
    // Forzar una nueva carga de la imagen añadiendo un timestamp como parámetro
    const timestamp = new Date().getTime();
    setImageUrl(`${webcamUrl}?t=${timestamp}`);
  }, 5 * 60 * 1000); // 5 minutos en milisegundos

  // Limpiar el intervalo cuando el componente se desmonte
  return () => clearInterval(intervalId);
}, [webcamUrl]); // Dependencia en webcamUrl para que se reinicie si la URL cambia


Dust
const windy_iframe_tpl = "https://embed.windy.com/embed.html?type=map&location=coordinates&metricRain=mm&metricTemp=°C&metricWind=m/s&zoom=6&overlay=dustsm&product=cams&level=surface&lat=28.227&lon=-15.754";
  
hclouds
<iframe width="650" height="450" src="https://embed.windy.com/embed.html?type=map&location=coordinates&metricRain=mm&metricTemp=°C&metricWind=m/s&zoom=6&overlay=hclouds&product=ecmwf&level=surface&lat=28.227&lon=-15.754" frameborder="0"></iframe>

mclouds
<iframe width="650" height="450" src="https://embed.windy.com/embed.html?type=map&location=coordinates&metricRain=mm&metricTemp=°C&metricWind=m/s&zoom=6&overlay=mclouds&product=ecmwf&level=surface&lat=28.227&lon=-15.754" frameborder="0"></iframe>



  return (
    <div>
      <iframe width="650" height="450" src={windy_iframe_tpl} frameborder="0"></iframe>
      <img
        src={imageUrl}
        alt={title || "Imagen de la webcam"}
        style={{ maxWidth: '100%', height: 'auto' }}
        className='border border-1 border-secondary'
      />
      <div className='fs-6 text-secondary'>{title || "Imagen de la webcam"}</div>
    </div>
  );
   */
}

export default Realtime;